import { createContext, useContext, useMemo } from 'react'

const OrphanedMessagesContext = createContext<Set<number>>(new Set())

interface OrphanedMessagesProviderProps {
  children: React.ReactNode
  orphanedMessageIds: number[]
}

export function OrphanedMessagesProvider({
  children,
  orphanedMessageIds
}: OrphanedMessagesProviderProps) {
  const orphanedSet = useMemo(() => new Set(orphanedMessageIds), [orphanedMessageIds])

  return (
    <OrphanedMessagesContext.Provider value={orphanedSet}>
      {children}
    </OrphanedMessagesContext.Provider>
  )
}

export function useOrphanedMessages() {
  return useContext(OrphanedMessagesContext)
}
